import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { actionType, getModuleType } from "../../../utils/tools";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { LessonPlanAPIs } from "../../LessonPlan/api";

import Video from "./VideoPlayer";
import PDFViewer from "./PdfViewer";
import Audio from "./AudioPlayer";
import Document from "./Document";
import Image from "./ImageViewer";
import Activity from "./Activity";
import Tracker from "./Tracker";

function Viewer(props) {
  return (
    {
      view: <Document link={props.fileUrl} />,
      audio: <Audio link={props.fileUrl} />,
      video: <Video link={props.fileUrl} />,
      watch: <Video link={props.fileUrl} />,
      show: <Image link={props.fileUrl} />,
      pdfview: <PDFViewer link={props.fileUrl} />,
      activity:<Activity link={props.fileUrl} />
    }[props.viewer] || <></>
  );
}

function Message({ children }) {
  return (
    <div style={{ margin: "150px auto" }}>
      <p style={{ margin: "auto", textAlign: "center" }}>{children}</p>
    </div>
  );
}

export default function Media(props) {
  const params = useParams();
  const [url, setURL] = useState({ link: "", viewer: "", loading: "", moduleName:"" });

  function fetchModule() {
    //fetch module
    axios
      .get(LessonPlanAPIs.getModule(params.module), {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
        validateStatus: () => true,
      })
      .then((res) => {
        if (res.data.status !== "success") throw res.data;
        const moduleType = getModuleType(res.data.data?.module?.resources);
        setURL({
          loading: "loaded",
          link: moduleType.resource?.fileUrl,
          viewer: actionType(moduleType.fileType),
          moduleName:res.data?.data?.module?.name || ""
        });
      })
      .catch((err) => {
        console.log(err.message);
        setURL({ ...url, loading: "loaded" });
      });
  }

  useEffect(() => {
    if (url.loading === "loading") return;
    setURL({ ...url, loading: "loading" });
    if (props.location.useProps?.fileUrl) {
      setURL({
        link: props.location.useProps?.fileUrl,
        viewer: props.location.useProps?.viewer,
        moduleName:props.location.useProps?.moduleName,
        loading: "loading",
      });
    } else {
      fetchModule();
    }
  }, [props.location]);

  useEffect(() => {
    if (props?.location?.useProps?.click) {
      props.location.useProps.click();
    }
  }, []);

  const moduleName = useMemo(() => url.moduleName,[url]);

  return (
    <Tracker moduleName={moduleName}>
      {url.link ? <Viewer viewer={url.viewer} fileUrl={url.link} /> : null}
      {!url.loading && url.loading === "loading" ? (
        <Message>Loading module...</Message>
      ) : null}
      {!url.link && url.loading === "loading" ? (
        <Message>Module not found</Message>
      ) : null}
    </Tracker>
  );
}
